import React, { useState } from 'react';
import ReusableDiv from 'src/helper/ReusableDiv';
import { useAccountStore } from "src/hooks/admin/account";
import useReduxState from 'src/hooks/useReduxState';
import System from 'src/helper/system';
import { useUserStore } from 'src/hooks/admin/user';
import { useAxiosIndicatorCheck } from "src/store/hook/useAxiosIndicatorCheck";
import { __remove, __set } from "src/store/axios_indicator";
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';

const UnsponsorUserAcct = (props) => {
    const { data, SetStatus } = props;
    const [{ }, { }, { update_unsponsor_acct_by_user }] = useAccountStore();
    const [{ }, { }, { update_unsponsor_user_acct }] = useUserStore();
    const [, setRefreshGrid] = useReduxState(false, 'setRefreshGrid');
    const [{ }, { system_alert_indicator }, { }] = useDOMAttachToSystemStore();

    const [__check] = useAxiosIndicatorCheck();
    const { translation:t } = System;
    const queryPrams = System.getParams()
    const onHide = () => {
        SetStatus(false)
    };

    const onSubmit = async () => {
        if (data.base === 'userDetails') {
            let params = {
                userId: data.userId,
                accountDetails: data.list.map((acc) => {
                    return {
                        accountNumber: acc.AccountNumber,
                        speedboat: System.avUserInfoData.speedBoatAbbr,
                        salesOrg: acc.SalesOrg,
                    }
                })
            }
            __set("UN_SPONSOR_API_CALL");
            await update_unsponsor_user_acct(params)
                .then((data) => {
                    system_alert_indicator({
                        name: "adminconsole",
                        message: t('userHaseBeenSuccessfully')+"<b>"+t('unsponsored')+"</b>"+t('fromAccounts'),
                        type: "success",
                        isDisplay: true,
                    });

                    setRefreshGrid(true);
                    onHide();
                    __remove("UN_SPONSOR_API_CALL");
                }).catch((err) => {
                    system_alert_indicator({
                        name: "adminconsole",
                        message: err.response.data.message || t('somethingWentWrong'),
                        type: "danger",
                        isDisplayIcon: true,
                        isDisplay: false,
                    });
                    __remove("UN_SPONSOR_API_CALL");
                })
        } else {
            let params = {
                ...queryPrams,
                userId: data.list.map(user => user.UserId),
            }
            __set("UN_SPONSOR_API_CALL");
            await update_unsponsor_acct_by_user(params)
                .then((data) => {
                    system_alert_indicator({
                        name: "adminconsole",
                        message: t('usersHaseBeenSuccessfully')+"<b>"+t('unsponsored')+"</b>"+t('fromAccount'),
                        type: "success",
                        isDisplay: true,
                    });
                    setRefreshGrid(true);
                    onHide();
                    __remove("UN_SPONSOR_API_CALL");
                }).catch((err) => {
                    system_alert_indicator({
                        name: "adminconsole",
                        message: err.response.data.message || t('somethingWentWrong'),
                        type: "danger",
                        isDisplayIcon: true,
                        isDisplay: false,
                    });
                    __remove("UN_SPONSOR_API_CALL");
                })
        }
    };

    return (
        <>
            <div className="avnet-modal modal-730 unsponsor-modal">
                <div className="avnet-modal-inner">
                    <button type="button" className="close py-3" data-dismiss="modal"
                            disabled={__check(["UN_SPONSOR_API_CALL"]).status}
                        onClick={onHide}>×</button>

                    {data.base === 'userDetails' ? ReusableDiv.PopupTitle(t('unsponserFromAccount')) : ReusableDiv.PopupTitle(t('unsponserUsersFromAccount'))}
                    <div className="modal-body">
                        <p className="text-center"> <strong> {data.base === 'userDetails' ? t('unsponserThisUserFromAccount') : t('unsponsorUsers')} </strong></p>

                        <table className="bs5 table table-bordered mt-4 mb-4">
                            <thead>
                                {data.base === 'userDetails' ?
                                    <tr>
                                        <th>{t('accountNumber')?.toUpperCase?.()}</th>
                                        <th>{t('accountName')?.toUpperCase?.()}</th>
                                        <th>{t('salesOrg')?.toUpperCase?.()}</th>
                                    </tr> :
                                    <tr>
                                        <th>{t('email')?.toUpperCase?.()} </th>
                                        <th>{t('firstName')?.toUpperCase?.()} </th>
                                        <th>{t('lastName')?.toUpperCase?.()}</th>
                                    </tr>}
                            </thead>
                            <tbody>
                                {data.base === 'userDetails' ?
                                    data?.list?.map((v, i) => (

                                        <tr key={i}>
                                            <td>{v?.AccountNumber} </td>
                                            <td>{v?.AccountName} </td>
                                            <td>{v?.SalesOrg} </td>
                                        </tr>
                                    )) :
                                    data.list.map((v, i) => (
                                        <tr key={i}>
                                            <td>{v?.Email} </td>
                                            <td className='text-break'>{v?.FirstName} </td>
                                            <td className='text-break'>{v?.LastName} </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                        {data.base === 'userDetails' ? <p className="text-center">
                            {t('thisActionCanNotBeReversed')}
                        </p> :
                            <p className="text-center">
                                {t('unsponsorUserFromAccount')}
                            </p>
                        }


                    </div>
                    <div className="modal-footer d-flex justify-content-center">
                        <button type="button" className="bs5 btn btn-secondary minw140"
                                disabled={__check(["UN_SPONSOR_API_CALL"]).status}
                            onClick={onHide}>{t('cancel')}</button>
                        <button
                            type="button"
                            className="bs5 btn btn-primary minw140"
                            disabled={__check(["UN_SPONSOR_API_CALL"]).status}
                            onClick={onSubmit}
                        >
                            {__check("UN_SPONSOR_API_CALL").status ?  <i className="fa fa-spinner fa-spin" /> : 'OK'}
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default UnsponsorUserAcct;